import { usePathname } from 'expo-router';
import { useCallback, useEffect, useRef } from 'react';

export function usePathnameRef() {
  const pathname = usePathname();
  const pathnameRef = useRef(pathname);

  useEffect(() => {
    pathnameRef.current = pathname;
  }, [pathname]);

  const getCurrentPathname = useCallback(() => {
    return pathnameRef.current;
  }, []);

  return {
    pathnameRef,
    getCurrentPathname,
  };
}
